import { render, staticRenderFns } from "./BaseRoundedButton.vue?vue&type=template&id=224ea3d5"
import script from "./BaseRoundedButton.vue?vue&type=script&lang=ts"
export * from "./BaseRoundedButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports